"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMobilePromoStateFull = exports.defaultMobilePromoStateNormal = exports.defaultMobilePromoStateSm = exports.defaultMobilePromoState = void 0;
var MobilePromoState_1 = require("@/pages/common/states/MobilePromoState");
exports.defaultMobilePromoState = {
    layout: MobilePromoState_1.MobilePromoLayout.NONE,
    isActive: false,
    downloadLink: 'https://www.okay.com/general/mobileapps',
    featureAlerts: 'Alerts so you don\'t miss out',
    featureLanguages: 'Browse in your language',
    featureListings: 'Over 7,000 property listings',
    featureNearby: 'Instantly find properties nearby',
    language: 'en',
    screencap: 'mapb',
    searchLink: 'https://www.okay.com',
    testVersionId: 'test-a-1',
    title: 'Download our app',
    testTrackingId: '123-456-abcd',
};
exports.defaultMobilePromoStateSm = __assign(__assign({}, exports.defaultMobilePromoState), { layout: MobilePromoState_1.MobilePromoLayout.SMALL, isActive: false });
exports.defaultMobilePromoStateNormal = __assign(__assign({}, exports.defaultMobilePromoState), { layout: MobilePromoState_1.MobilePromoLayout.NORMAL, isActive: false });
exports.defaultMobilePromoStateFull = __assign(__assign({}, exports.defaultMobilePromoState), { layout: MobilePromoState_1.MobilePromoLayout.FULL, isActive: false });
